import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, delay, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { TokenStorageService } from '@/app/auth/services/token-storage.service';
import { loadUser } from '@/app/dashboard/store/dashboard.actions';
import { EmergencyControlService } from '../services/emergency-control.service';
import * as EmergencyControlActions from './emergency-control.actions';

@Injectable()
export class EmergencyControlEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(EmergencyControlService);
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly tokenStorage = inject(TokenStorageService);
  private readonly translate = inject(TranslateService);

  readonly unfreezeAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmergencyControlActions.unfreezeAccount),
      switchMap(({ reason }) =>
        this.service.unfreezeAccount(reason).pipe(
          switchMap(res =>
            of(
              EmergencyControlActions.unfreezeAccountSuccess({
                response: res?.data,
              }),
              loadUser()
            ).pipe(delay(2000))
          ),
          catchError(err =>
            of(
              EmergencyControlActions.unfreezeAccountFailure({
                error:
                  err?.message ??
                  this.translate.instant(
                    'emergencyControl.errors.unfreezeFailed'
                  ),
              })
            )
          )
        )
      )
    )
  );

  readonly loadFreezeNotice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmergencyControlActions.loadFreezeNotice),
      switchMap(() =>
        this.service.getFreezeNotice().pipe(
          switchMap(res =>
            of(
              EmergencyControlActions.loadFreezeNoticeSuccess({
                freezeNotice: res?.data,
              })
            )
          ),
          catchError(err =>
            of(
              EmergencyControlActions.loadFreezeNoticeFailure({
                error:
                  err?.message ??
                  this.translate.instant(
                    'emergencyControl.errors.loadFreezeNoticeFailed'
                  ),
              })
            )
          )
        )
      )
    )
  );
}
